import { AppEngine } from "@shared/types/localtypes.ts";

const engine = AppEngine.WEB;
export default engine;
